<template>
  <couponCard/>
</template>

<script>
import couponCard from './components/couponCard'
export default {
  components: {
    couponCard
  },
  data () {
    return {
      breadCrumbs: [{
        label: '首页'
      }, {
        label: '个人中心'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.myOwnOrder {
    width: 100%;
}
</style>
